export * from './lib/core-sound-service.module';
export * from './lib/audio-controller/audio-controller.class';
// export * from './lib/sound.dictionary';
export * from './lib/sound.interface';
export * from './lib/sound.service';
